import { render, staticRenderFns } from "./SendPic.vue?vue&type=template&id=0e99c3e2&scoped=true&"
import script from "./SendPic.vue?vue&type=script&lang=js&"
export * from "./SendPic.vue?vue&type=script&lang=js&"
import style0 from "./SendPic.vue?vue&type=style&index=0&id=0e99c3e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e99c3e2",
  null
  
)

export default component.exports